<!-- 报表查询组件 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <div class="page_content_top_line">
                <el-form @submit.native.prevent :inline="true" ref="getRequestData" :model="getRequestData" label-width="100px" :hide-required-asterisk="false" class="demo-form-inline dis" size="mini"
                         v-if="reportConditionVos.length > 0" :show-message="false">
                    <template v-for="(formOneValue, formOneKey) in reportConditionVos">
                        <el-form-item :prop="formOneValue.fieldEntity" :rules="[{ required: formOneValue.isReq == 1, trigger: ['blur', 'change'] }]" class="pd" :key="formOneKey" v-if="formOneValue.isShow == 1">
                            <label slot="label" :style="$common.labelStyle(formOneValue.fieldShow)" v-html="$common.htmlLabel(formOneValue.fieldShow)"></label>
                            <el-input @input="$forceUpdate()" clearable class="form_codition" v-if="formOneValue.fieldType == 'string'" @change="((val) => { handleChange(val, formOneValue.fieldEntity) })"
                                      :placeholder="'请输入' + formOneValue.fieldShow" v-model.trim="getRequestData[formOneValue.fieldEntity]" size="mini">
                            </el-input>
                            <el-date-picker class="form_codition" v-else-if="formOneValue.fieldEntity == 'start' || formOneValue.fieldEntity == 'start2'" size="mini" v-model="getRequestData[formOneValue.fieldEntity]"
                                            format="yyyy年MM月dd日" value-format="timestamp" type="date" placeholder="选择日期">
                            </el-date-picker>
                            <el-date-picker class="form_codition" v-else-if="formOneValue.fieldEntity == 'end' ||
                     formOneValue.fieldEntity == 'end2'" @change="changeTime" size="mini" @focus="timeFocus(formOneValue.fieldEntity)" v-model="getRequestData[formOneValue.fieldEntity]" format="yyyy年MM月dd日"
                                            value-format="timestamp" type="date" placeholder="选择日期">
                            </el-date-picker>
                            <el-input @input="$forceUpdate()" class="form_codition" type="number" v-else-if="formOneValue.fieldType == 'number'" @change="((val) => { handleChange(val, formOneValue.fieldEntity) })"
                                      :placeholder="'请输入' + formOneValue.fieldShow" v-model.number="getRequestData[formOneValue.fieldEntity]" size="mini">
                            </el-input>
                            <el-input class="form_codition" @input="$forceUpdate()" v-else-if="formOneValue.fieldType == 'search'" @change="claerValue(formOneValue.fieldEntity, formOneValue.paramField)"
                                      @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.fieldEntity, formOneValue.paramField)" clearable v-model="getRequestData[formOneValue.fieldEntity]">
                                <el-button @click="openSearch(formOneValue.searchId, formOneValue.fieldEntity, formOneValue.paramField)" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                            <el-select clearable size="mini" class="form_codition" v-else-if="formOneValue.fieldType == 'formatter'" @change="$forceUpdate()" v-model="getRequestData[formOneValue.fieldEntity]"
                                       placeholder="请选择">
                                <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value">
                                </el-option>
                            </el-select>
                            <el-input class="form_codition" @keyup.enter.native="searchData('getRequestData')" clearable v-else v-model.trim="getRequestData[formOneValue.fieldEntity]"
                                      @change="((val) => { handleChange(val, formOneValue.fieldEntity) })" @input="$forceUpdate()">
                            </el-input>
                        </el-form-item>
                    </template>
                    <el-form-item class="pd">
                        <el-button type="primary" size="mini" icon="el-icon-search" @click="searchData('getRequestData')">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <v-tabs v-if="reportModuleVos.length > 0" :type="60" :activeName="activeName" :name="'rpmName'" :tabslist="reportModuleVos" @openFormDesign="openFormDesign">
            <template slot="btn">
                <li>
                    <el-tooltip class="item" effect="dark" content="刷新" placement="top">
                        <i class="el-icon-refresh icons" @click="getPageInfo()"></i>
                    </el-tooltip>
                </li>
                <li>
                    <el-tooltip class="item" effect="dark" content="汇总" placement="top">
                        <i class="el-icon-s-data icons" @click="totalQueryData('recordSummary')"></i>
                    </el-tooltip>
                </li>
                <li>
                    <el-tooltip class="item" effect="dark" content="过滤" placement="top">
                        <i class="el-icon-edit-outline icons" @click="totalQueryData('recordFiltering')"></i>
                    </el-tooltip>
                </li>
                <li v-if="opmExport == 1">
                    <el-tooltip class="item" effect="dark" content="导出" placement="top">
                        <i class="el-icon-download icons" @click="totalQueryData('exportData')"></i>
                    </el-tooltip>
                </li>
                <li v-if="isPrint == 1">
                    <el-tooltip class="item" effect="dark" content="打印" placement="top">
                        <i class="el-icon-printer icons" @click="totalQueryData('showPrintPlan')"></i>
                    </el-tooltip>
                </li>
            </template>
            <template slot="tabs" slot-scope="scope">
                <div v-if="reportModuleVos" class="page_content_center">
                    <div class="watermark"></div>
                    <div class="top_chart" id="topChart" :style="`height:${tableHeight / 2}px`">

                    </div>
                    <u-table class="uTable" ref="uTable" @header-dragend="handleColumnWidthChange" :data="returnData.list" @row-click="rowClick" :key="$store.state.tableNum" :row-style="rowStyle"
                             :show-summary="totalField.length > 0" :row-class-name="tableRowClassName" :summary-method="getSummaries" :row-height="20" :height="tableHeight / 2" row-key="index" use-virtual
                             :big-data-checkbox="true" @sort-change="(column) => { sortChange(column, scope.row.desysReportTableVos) }" :highlight-current-row="false" size="mini" border>
                        <u-table-column align="center" width="50" label="序号" fixed="left">
                            <template slot-scope="scope">
                                {{ scope.$index + 1 + (getRequestData.page - 1) * getRequestData.rows }}
                            </template>
                        </u-table-column>
                        <template v-for="(tableValye, tableKey) in scope.row.desysReportTableVos">
                            <u-table-column align="center" :key="tableKey" show-overflow-tooltip v-if="tableValye.isShow == 1" :min-width="tableValye.fieldWeight" :prop="tableValye.fieldEntity"
                                            :label="tableValye.fieldShow" :sortable="tableValye.isSort == 1 && tableValye.fieldType == 'number' ? 'custom' : tableValye.isSort == 1 ? true : false">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.fieldEntity]">
                                        {{ $common.getLocalTime(scope.row[tableValye.fieldEntity]) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.fieldEntity]">
                                        {{ $common.getLocalTime(scope.row[tableValye.fieldEntity], true) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'formatter'">
                                        <span v-if="scope.row[tableValye.fieldEntity] !== ''">
                                            <el-tag size="mini">
                                                {{getValue(scope.row[tableValye.fieldEntity], tableValye.fieldEntity,tableValye.fieldType, tableValye.formatterContent)}}
                                            </el-tag>
                                        </span>
                                    </span>
                                    <div v-else-if="tableValye.fieldType == 'imgUrl'">
                                        <span v-if="scope.row[tableValye.fieldEntity]">
                                            <span v-for="(item, index) in scope.row[tableValye.fieldEntity].split(',')" :key="index">
                                                <cusImage style="width: 30px; height: 30px;margin-top: 5px;" :src="`${imgUrl}/${item}`" :preview-src-list="[`${imgUrl}/${item}`]">
                                                </cusImage>
                                            </span>
                                        </span>
                                    </div>
                                    <span v-else-if="tableValye.fieldEntity == 'createTime' && scope.row[tableValye.fieldEntity]">
                                        {{ $common.getLocalTime(scope.row[tableValye.fieldEntity], true) }}
                                    </span>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{
                              scope.row[tableValye.fieldEntity]
                              }}</a>
                                    </span>
                                    <span v-else>
                                        {{ scope.row[tableValye.fieldEntity] }}
                                    </span>
                                </template>
                            </u-table-column>
                        </template>
                    </u-table>
                </div>
            </template>
        </v-tabs>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber" :pageSize="rpmPage"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <recordSummary ref="recordSummary"></recordSummary>
        <recordFiltering ref="recordFiltering"></recordFiltering>
        <customDesignReport ref="customDesignReport"></customDesignReport>
    </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
    exportRecordAdd
} from "@/service/printApi.js";
import NP from "number-precision";
import * as echarts from 'echarts';
import { EleResize } from '@/common/esresize';
export default {
    name: "dataQueryTemplateChart",
    components: {},
    //import引入的组件需要注入到对象中才能使用
    data() {
        //这里存放数据
        return {
            getRequestData: {},
            reportName: '',
            fullscreenLoading: false,
            activeName: "report0",
            returnData: {
                total: 0, // 总条数
                list: [],
                pageSizes: [],//分页列表
                totalData: [],//总数据
            },
            buttonList: [],
            formDataList: [],
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: "",
            smId: "",
            reportConditionVos: [],
            reportModuleVos: [],
            excelData: [],
            rpmPage: [],
            rpmName: "",
            searchField: "",
            paramField: "",
            parentSearchData: {},
            selectedDataIndex: '',
            requesUrl: "",
            imgUrl: "",
            dataInfo: {},
            isJxqPrint: false,
            totalField: [],
            numberField: [],
            stringField: [],
            isOpmParam: false,
            timeField: '',
            bgData: [],
            opmExport: 0,
            isPrint: 0,
            allData: {},
            rpcId: "",
            tableHeight: 0,
            actionData: {},
            textTitle: "",

        };
    },
    watch: {
        'activeName': function (a, b) {
            const res = a.slice(a.length - 1, a.length)
            this.rpmPage = this.allData.reportModuleVos[res].rpmPage.split(',').map(item => {
                return parseInt(item)
            })
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //方法集合
    methods: {
        getValue(val, type, fieldType, arr) {
            var str = ""
            var value = ""
            if (String(Number(val)) != NaN) {
                value = Number(val)
            } else {
                value = val
            }
            if (fieldType == 'formatter') {
                if (arr && arr != null && arr != '') {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && Number(item.value) === value) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && Number(item.key) === value) {
                            str = item.value
                        } else {
                            if (item.value == value) {
                                str = item.key
                            } else if (item.key == value) {
                                str = item.value
                            }
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        sortChange(column, typeList) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, typeList, 'fieldEntity')
        },
        addWatermark(text) {
            const watermarkDiv = document.querySelector('.watermark');
            const canvas = document.createElement('canvas');
            canvas.width = 400;
            canvas.height = 120;
            const ctx = canvas.getContext('2d');
            ctx.rotate(-20 * Math.PI / 280);
            ctx.font = '18px Arial';
            ctx.fillStyle = 'rgba(200, 200, 200, 0.25)';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(text, canvas.width / 2, canvas.height / 1);
            watermarkDiv.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`;
            watermarkDiv.style.pointerEvents = 'none';
            watermarkDiv.style.position = 'absolute';
            watermarkDiv.style.top = 0;
            watermarkDiv.style.left = 0;
            watermarkDiv.style.width = '100%';
            watermarkDiv.style.height = '100%';
            watermarkDiv.style.zIndex = 1000;
        },
        getPageInfo() {
            this.activeName = 'report0'
            this.reportModuleVos = []
            this.returnData.list = []
            this.returnData.totalData = []
            this.getRequestData.page = 1
            this.$set(this.getRequestData, "page", 1)
            this.$set(this.getRequestData, "rows", Number(this.returnData.pageSizeList[0]))
            this.getFormList()
        },
        handleColumnWidthChange(newWidth, oldWidth, column, event) {
            this.reportModuleVos[this.activeName.slice(this.activeName.length - 1)].desysReportTableVos.forEach(item => {
                if (item.fieldEntity == column.property) {
                    item.fieldWeight = NP.round(newWidth, 2)
                }
            })
        },
        openFormDesign() {
            var pageShowData = {
                reportConditionVos: this.reportConditionVos,
                reportModuleVos: this.reportModuleVos,
            }
            this.$refs['customDesignReport'].openBox(this.rpcId, pageShowData, this.reportName)
        },
        timeFocus(e) {
            this.timeField = e
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData[this.timeField] = time;
            }
        },
        // 记录汇总
        recordSummary() {
            this.numberField = []
            this.stringField = []
            let nowFieldJur = this.reportModuleVos[this.activeName.split('report')[1]].desysReportTableVos
            var activeIndex = Number(
                this.activeName.charAt(this.activeName.length - 1)
            );
            let rpcName = this.reportModuleVos[activeIndex].rpmName; //获取当前导出表格标题
            nowFieldJur.forEach((key) => {
                if (key.isShow == 0) return
                if (key.fieldType == 'number') {
                    this.numberField.push(key)
                    return
                }
                this.stringField.push(key)
            })
            let sendData = {
                numberField: this.numberField,
                stringField: this.stringField,
                list: this.returnData.totalData,
                rpcName: rpcName
            }
            this.$refs.recordSummary.openBox(sendData)
        },
        // 记录过滤
        recordFiltering() {
            let nowFieldJur = this.reportModuleVos[this.activeName.split('report')[1]].desysReportTableVos
            var activeIndex = Number(
                this.activeName.charAt(this.activeName.length - 1)
            );
            let rpcName = this.reportModuleVos[activeIndex].rpmName; //获取当前导出表格标题
            let sendData = {
                nowFieldJur: nowFieldJur,
                list: this.returnData.totalData,
                rpcName: rpcName
            }
            this.$refs.recordFiltering.openBox(sendData)
        },
        // 自定义合计字段
        getSummaries({ columns, data }) {
            let sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (this.totalField.includes(column.property)) {
                    let validValues = data
                        .map(item => {
                            let value = item[column.property];
                            // 处理各种可能的空值情况
                            if (value === null || value === undefined || value === '') {
                                return 0;
                            }
                            return isNaN(value) ? 0 : value;
                        })
                        .filter(num => !isNaN(num));
                    if (validValues.length > 0) {
                        // 使用 reduce 计算总和，并处理浮点数精度问题
                        let sum = validValues.reduce((prev, curr) => {
                            return NP.plus(Number(prev), Number(curr));
                        }, 0);
                        // 格式化显示，使用系统统一的格式化方法
                        sums[index] = this.$common.getDecimalInfo(3, sum);
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = ''
                }
            });
            return [sums];
        },
        rowClick(row, column, event) {
            this.selectedDataIndex = row.isIndex
            this.getChart()
        },
        // 下载压缩包
        downZip() {
            this.dataInfo.pihao = this.dataInfo.pihao.replace("#", "$");
            window.location.href =
                this.requesUrl +
                "/bgStock/downInspectionFileZip?pihao=" +
                this.dataInfo.pihao +
                "&&spid=" +
                this.dataInfo.spid;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, field, paramField) {
            if (field == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.searchField = field;
            this.paramField = paramField;
            this.DialogVisible = true;
            this.seId = sId;

            this.parentSearchData[field] = this.getRequestData[field];

        },
        // 赋值字段
        paramValue(val) {
            let arr = this.paramField.split(',')
            arr.forEach(item => {
                // 查询方案添加参数
                this.parentSearchData[item] = val[item]
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(paramField) {
            let arr = paramField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.getRequestData[this.searchField] = val[this.searchField];
                // this.getRequestData[this.paramField] = val[this.paramField];
                this.paramValue(val)
            }
        },
        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            let rowBackground = {}
            if (row.hasOwnProperty('color')) {
                if (row.color && row.color != '') rowBackground.backgroundColor = row.color
            } else if (row.hasOwnProperty('bgColor')) {
                if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            }

            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.isIndex == this.selectedDataIndex) return 'current_row';
        },
        toDetail(orderId) {
            this.$parent.toDetail(orderId);
        },
        dealTime(shijianchuo) {
            var time = new Date(shijianchuo);
            var y = time.getFullYear();
            var m = time.getMonth() + 1;
            var d = time.getDate();
            return y + '年' + m + '月' + d + '日'
        },
        showPrintPlan() {
            var params = {}
            for (const key in this.getRequestData) {
                this.$set(params, key, this.getRequestData[key])
            }
            //数据列表
            if (params.start && params.end) {
                params.start = this.dealTime(params.start)
                params.end = this.dealTime(params.end)
            }
            if (params.start2 && params.end2) {
                params.start2 = this.dealTime(params.start2)
                params.end2 = this.dealTime(params.end2)
            }
            if (params.bgmId == '') delete params.bgmId
            if (params.page) delete params.page
            if (params.smId == '') delete params.smId
            const sxobj = {}
            this.reportConditionVos.forEach(item => {
                sxobj[item.fieldEntity] = item.fieldShow
            })
            //表格信息（表格名表格数据条数等）
            const obj = {}
            const tableIndex = this.activeName.slice(6, 7)
            this.reportModuleVos[tableIndex].desysReportTableVos.forEach(item => {
                obj[item.fieldEntity] = item.fieldShow
            })
            const toDealTime = []
            const toDealTime1 = []
            this.reportModuleVos[tableIndex].desysReportTableVos.forEach(item => {
                if (item.fieldType == 'date') {
                    toDealTime.push(item.fieldEntity)
                }
                if (item.fieldType == 'datetime') {
                    toDealTime.push(item.fieldEntity)
                }
            })
            const cloneList = JSON.parse(JSON.stringify(this.returnData.totalData))
            const dataList = cloneList.map(item => {
                toDealTime.forEach(item2 => {
                    if (Object.keys(item).includes(item2)) {
                        item[item2] = this.$common.getLocalTime(item[item2])
                    }
                })
                toDealTime1.forEach(item2 => {
                    if (Object.keys(item).includes(item2)) {
                        item[item2] = this.$common.getLocalTime(item[item2], true)
                    }
                })
                return item
            })
            //过滤条件
            var jomsg = {
                "scheme": "print",
                "data": {
                    "route": "design",
                    "param": {
                        "reportkey": sessionStorage.getItem('printJurId'),
                        "reportname": this.reportModuleVos[tableIndex].rpmName,
                        "reportmod": "",
                        "variables": {},
                        "ShowPrintDialog": true,
                        "PrintCopys": 1,
                        "userdata": [
                            {
                                "rowcount": dataList.length,
                                "rows": dataList,
                                "cols": obj,
                                "tableName": this.reportModuleVos[tableIndex].rpmName
                            }, {
                                "rowcount": 1,
                                "rows": [params],
                                "cols": sxobj,
                                "tableName": "查询条件"
                            }
                        ]
                    }
                }
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                let printSource = sessionStorage.getItem('printSource').replace(/\"/g, "")
                console.log(jomsg, "测试123");

                // 选中的数据
                this.$refs.printPlan.openDia('报表打印', printSource, sessionStorage.getItem('printJurId'), '', '', this
                    .getRequestData, '', jomsg)
            } else {
                return
            }
            //打印数据


        },
        //触发按钮点击下载事件
        exportData() {
            this.excelData = this.returnData.totalData; //将你要导出的数组数据（historyList）赋值给excelDate
            this.export2Excel(); //调用export2Excel函数，填写表头（clomns里的type）和对应字段(historyList里的属性名)
        },
        //表格数据写入excel
        export2Excel() {
            var listBeiFen = JSON.parse(JSON.stringify(this.excelData))
            // tabindex
            var activeIndex = Number(
                this.activeName.charAt(this.activeName.length - 1)
            );
            this.rpmName = this.reportModuleVos[activeIndex].rpmName; //获取当前导出表格标题
            var nameList = []; //表格头 显示的所有字段
            var fieldList = []; //所有字段 显示的所有字段
            var timeList = []; //date类型的字段 导出之前进行格式转换
            var timeList1 = []; //date类型的字段 导出之前进行格式转换
            var formatterList = []; //"formatter"类型字段，格式转换
            let formatterSel = []
            // 循环当前tab表格信息
            this.reportModuleVos[activeIndex].desysReportTableVos.forEach((item) => {
                // 显示的字段//表头
                if (item.isShow == 1) {
                    nameList.push(item.fieldShow);
                    fieldList.push(item.fieldEntity);
                }
                // 如果为date类型push
                if (item.fieldType == "date") {
                    timeList.push(item.fieldEntity);
                }
                // 如果为date类型push
                if (item.fieldType == "dateTime") {
                    timeList1.push(item.fieldEntity);
                }
                //如果date类型为"formatter"
                if (item.fieldType == "formatter") {
                    formatterSel.push(item.formatterContent)
                    formatterList.push(item.fieldEntity)

                }

            });
            // 循环数据列表和时间字段数组 进行转换
            listBeiFen.forEach((item) => {
                timeList.forEach((timeitem) => {
                    if (item[timeitem] && String(item[timeitem]).indexOf('-') == -1) {
                        item[timeitem] = this.$common.getLocalTime(item[timeitem])
                    } else if (item[timeitem] && String(item[timeitem]).indexOf('-') != -1) {
                        item[timeitem] = item[timeitem];
                    } else {
                        item[timeitem] = ""
                    }
                });
                timeList1.forEach((timeitem) => {
                    if (item[timeitem] && String(item[timeitem]).indexOf('-') == -1) {
                        item[timeitem] = this.$common.getLocalTime(item[timeitem], true)
                    } else if (item[timeitem] && String(item[timeitem]).indexOf('-') != -1) {
                        item[timeitem] = item[timeitem];
                    } else {
                        item[timeitem] = ""
                    }
                });
            });
            // 循环数据列表和时间字段数组 进行转换
            listBeiFen.forEach((item) => {
                timeList1.forEach((timeitem) => {
                    if (item[timeitem] && String(item[timeitem]).indexOf('-') == -1) {
                        item[timeitem] = this.$common.getLocalTime(item[timeitem])
                    } else if (item[timeitem] && String(item[timeitem]).indexOf('-') != -1) {
                    } else {
                        item[timeitem] = ""
                    }
                });
            });
            //循环数据列表和formatter字段
            // listBeiFen.forEach((item) => {
            //    for (let j = 0; j <= formatterList.length; j++) {
            //       if (item[formatterList[j]] != null) {
            //          let num = item[formatterList[j]]
            //          var str = formatterSel[j].filter(val => val.key == num)
            //          if (str.length > 0) {
            //             item[formatterList[j]] = str[0].value
            //          } else {
            //             var str1 = formatterSel[j].filter(val => val.value == num)
            //             if (str1.length > 0) {
            //                item[formatterList[j]] = str1[0].key
            //             }
            //          }
            //       }

            //    }
            // });
            listBeiFen.forEach((item) => {
                formatterList.forEach((val, key) => {
                    if (item[val] != null) {
                        item[val] = this.getValue(item[val], val, 'formatter', formatterSel[key])
                    }
                })
            });
            if (this.totalField.findIndex(item => item == 'kpsj')) {
                this.totalField.splice(this.totalField.findIndex(item => item == 'kpsj'), 1)
            }
            if (this.totalField.findIndex(item => item == 'kpy')) {
                this.totalField.splice(this.totalField.findIndex(item => item == 'kpy'), 1)
            }
            this.totalField.forEach(item => {
                listBeiFen.forEach(key => {
                    key[item] = Number(key[item])
                })
            })
            // 导出业务逻辑 引用封装好的js方法
            require.ensure([], () => {
                const {
                    export_json_to_excel
                } = require("@/assets/excel/Export2Excel");
                //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
                const tHeader = nameList; // 导出的excel表头名信息
                const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
                const list = listBeiFen; // 查询的数据list
                // 进行数据json map 格式转换
                const data = this.formatJson(filterVal, list);
                // 调用方法传参      表头名信息 数据  导出的表格名称
                export_json_to_excel(tHeader, data, this.rpmName);


            });
            // 导出次数接口
            var token = sessionStorage.getItem("token");
            let params = {
                exportCount: listBeiFen.length,
                featuresName: this.rpmName
            }
            exportRecordAdd(params, token).then((res) => {
                if (res.status === 200) { }
            });
            this.searchData('getRequestData')
        },
        //格式转换方法
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        handleChange(value, name) {
            // value默认参，name当前所需的name
            this.getRequestData[name] = value;
            this.$forceUpdate()
        },
        isNull(value) {
            if (!value && typeof value != "undefined" && value != 0) {
                return true;
            }
            return false;
        },
        // 获取对应表单数据 渲染查询条件和表格头
        async getFormList() {
            let id = sessionStorage.getItem("reportId");
            const responseData = await this.$http.getUserReportPlanById({ ids: [id] })
            let reportData = responseData.result
            this.allData = reportData
            this.reportName = reportData.rpcName
            this.rpcId = reportData.rpcId
            this.opmExport = JSON.parse(sessionStorage.getItem('userInfo')).opmExport
            this.isPrint = JSON.parse(sessionStorage.getItem('userInfo')).isPrint
            this.rpmPage = reportData.reportModuleVos[0].rpmPage.split(',').map(item => {
                return parseInt(item)
            })
            this.reportConditionVos = reportData.reportConditionVos; // 检索条件
            this.reportModuleVos = reportData.reportModuleVos; // 表格头
            this.totalField = []
            this.reportModuleVos.forEach((item) => {
                item.desysReportTableVos.forEach((key) => {
                    if (key.isTotal == 1 && key.fieldType == 'number') {
                        this.totalField.push(key.fieldEntity)
                    }
                })
            });
            this.reportConditionVos.forEach((item) => {
                item.value = "";
                    if (item.paramField != '' && item.paramField != 'null' && item.paramField != null) {
                        this.initParamValue(item.paramField)
                    }
                    this.$set(this.getRequestData, item.fieldEntity, '')
                    // 特定条件
                    if (item.fieldEntity == "filter") {
                        this.getRequestData[item.fieldEntity] = JSON.parse(
                            item.formatterContent
                        )[0].value;
                    }
                    if (item.fieldEntity == "nearDays") {
                        this.getRequestData[item.fieldEntity] = item.defaultValue || 180;
                    }
                    if (item.defaultValue != null && item.defaultValue !== "") {
                        if (String(Number(item.defaultValue)) == 'NaN') {
                            this.$set(this.getRequestData, item.fieldEntity, item.defaultValue)
                        } else {
                            this.$set(this.getRequestData, item.fieldEntity, Number(item.defaultValue))
                        }
                    }
                if (sessionStorage.getItem('printJurId') == '1636607096099') this.isJxqPrint = true
            });
            this.returnData.pageSizeList = reportData.reportModuleVos[0].rpmPage.split(",");
            this.$set(this.getRequestData, "page", 1)
            this.$set(this.getRequestData, "rows", Number(this.returnData.pageSizeList[0]))
            this.setTime();
            setTimeout(() => {
                this.addWatermark(this.textTitle)
            }, 100)
        },
        totalQueryData(name) {
            this.getDataList(true, name)
        },
        // 数据搜索
        searchData(getRequestData) {
            this.tableHeight = this.$common.getTableHeight()
            this.$set(this.getRequestData, "page", 1)
            this.$set(this.getRequestData, "rows", Number(this.returnData.pageSizeList[0]))
            this.getDataList();
        },
        // 获取数据列表
        async getDataList(flag, name) {
            this.getRequestData.ormId = JSON.parse(
                sessionStorage.getItem("loginInfo")
            ).ormId;
            if (this.getRequestData.hasOwnProperty("opmId") && !this.isOpmParam) {
                this.getRequestData.opmId = JSON.parse(
                    sessionStorage.getItem("userInfo")
                ).opmId;
            }
            this.getRequestData.rpmId =
                this.reportModuleVos[Number(this.activeName.split('report')[1])].rpmId;
            for (let key in this.getRequestData) {
                if (this.isNull(this.getRequestData[key])) this.getRequestData[key] = ''
            }
            var params = JSON.parse(JSON.stringify(this.getRequestData))
            if (flag) {
                delete params.page
                delete params.rows
            }
            let responseData = await this.$http.getReportDataById(params);
            this.selectedDataIndex = 0
            if (responseData.status == 200) {
                if (!flag) {
                    this.returnData.list = responseData.rows;
                    this.returnData.list.forEach((item, index) => {
                        this.$set(item, 'isIndex', index)
                    })
                    this.returnData.total = responseData.total;
                    this.getChart()
                } else {
                    this.returnData.totalData = responseData.rows
                    if (name == 'recordSummary') {
                        this.recordSummary()
                    } else if (name == 'recordFiltering') {
                        this.recordFiltering()
                    } else if (name == 'exportData') {
                        this.exportData()
                    } else if (name == 'showPrintPlan') {
                        this.showPrintPlan()
                    }
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }

        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        setTime() {
            var day = JSON.parse(sessionStorage.getItem('printInfo')).days
            this.$set(
                this.getRequestData,
                "start",
                new Date(new Date().toLocaleDateString()).getTime() -
                day * 24 * 3600 * 1000
            );
            this.$set(
                this.getRequestData,
                "end",
                new Date(new Date().toLocaleDateString()).getTime() +
                24 * 60 * 60 * 1000 -
                1
            );
        },
        //获取图片存取的根路径
        imgurl() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 监听键盘事件
        keyUp(e) {
            if (e.keyCode == 13) {
                this.searchData('getRequestData')
            }

        },
        // 监听键盘事件
        keyUp1(e) {
            if (e.altKey && e.key === 'q') {
                // 阻止默认行为和事件冒泡
                e.preventDefault();
                e.stopPropagation();
                this.getDataList()
            }
        },
        getChart() {
            var chartDom = document.getElementById('topChart');
            var myChart = echarts.init(chartDom);
            var option;
            var listName = []
            var dataList = []
            var info = this.returnData.list[this.selectedDataIndex]
            this.reportModuleVos[Number(this.activeName.split('report')[1])].desysReportTableVos.forEach(item => {
                if (item.isShow == 1 && item.fieldEntity != 'storeName' && item.fieldEntity != 'totalMoney') {
                    listName.push(item.fieldShow)
                    dataList.push(info[item.fieldEntity])
                }
            })
            option = {
                title: {
                    text: this.reportModuleVos[Number(this.activeName.split('report')[1])].rpmName, // 主标题文本，支持使用 \n 换行
                    top: 0, // 定位 值: 'top', 'middle', 'bottom' 也可以是具体的值或者百分比
                    left: 'left', // 值: 'left', 'center', 'right' 同上
                    textStyle: { // 文本样式
                        fontSize: 15,
                        fontWeight: 500,
                        color: '#000000'
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                grid: {
                    left: 10,
                    right: 10,
                    bottom: 10,
                    top: 40,
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: listName,
                        axisPointer: {
                            type: 'shadow'
                        },
                        // axisLabel: {
                        // 	show: true,
                        // 	textStyle: {
                        // 		color: 'black'
                        // 	},
                        // 	lineStyle: {
                        // 		width: '5'
                        // 	},
                        // 	fontSize: 20,
                        // 	rotate: 70//旋转角度

                        // }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}',
                        }
                    }
                ],
                series: [
                    {
                        name: '数量',
                        type: 'bar',
                        data: dataList
                    },
                ]
            };

            option && myChart.setOption(option);
            let listener = function () {
                myChart && myChart.resize();
            };
            EleResize.on(document.getElementById('topChart'), listener);

        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.textTitle = `${JSON.parse(sessionStorage.getItem('userInfo')).opmName}@${sessionStorage.getItem('ormName')}`
        this.getFormList();
        this.imgurl();
    },
    mounted() {
        addEventListener("keydown", this.keyUp1); //创建监听键盘事件
        addEventListener("keyup", this.keyUp)
    }, //生命周期 - 挂载完成（可以访问DOM元素）
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    }, //生命周期 - 更新之后
    beforeDestroy() {
        removeEventListener("keydown", this.keyUp1);
        removeEventListener("keyup", this.keyUp);
    }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.top_chart {
    /* height: 250px; */
    width: 100%;
}

.watermark {
    background-repeat: repeat;
}

.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}

.page_content_center {
    position: relative;
    overflow-y: auto;
}

.dis {
    display: flex;
    flex-wrap: wrap !important;
}

.page_content_top_line {
    padding-bottom: 0;
}

.current_row {
    background-color: #ffdb12 !important;
}

/* .pd {
        padding-bottom: 6px;
    } */
</style>
<style>
.el-table .red {
    background: #f5d3d3;
}

.el-table .yellow {
    background: #f5e4d3;
}

::-webkit-scrollbar {
    width: 8px;
    /*垂直方向的宽*/
    height: 10px;
    /*水平方向的宽*/
}

/* 滑块 */
::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    background-image: none !important;
}

/* 滑块背景 */
::-webkit-scrollbar-track {
    background-color: #ffffff00 !important;
    border-radius: 17px;
    /* background: rgba(173, 28, 31, 0.05); */
    box-shadow: none !important;
    /* -moz-box-shadow: none;
    -webkit-box-shadow: none; */
}
</style>